// extracted by mini-css-extract-plugin
module.exports = {"areYouReady":"are-you-ready_areYouReady__1Y3gT"};